import { Injectable } from '@angular/core';
import { AppConfig } from '../model/config';
import { HttpHelper } from './http.service';
import { Bus } from '../model/bus';
import { BusServiceDto, Service } from '../administration/busses/manage-bus/manage-bus.component';
import { BusWithOverlaps } from '../model/busWithOverlap';

@Injectable()
export class BusService {

  constructor(private readonly httpClient: HttpHelper, private readonly configuration: AppConfig) {
  }
  // get available buses
  async getAvailableBuses(availabilityId: string, start: Date, end: Date) {
    let url: string = this.configuration.backendUrl + "/api/bus/available";

    return await this.httpClient.post(url,
      {
        "availabilityId": availabilityId,
        "start": start,
        "end": end
      },
      () => { },
      () => { }).toPromise<BusWithOverlaps[]>();
  }

  // all busses
  async getAllBuses() {

    let url: string = this.configuration.backendUrl + "/api/bus";

    return await this.httpClient.get(url, () => { },
      () => { }).toPromise<Bus[]>();
  }

  //all servcices for bus
  async getBusServices(id:string): Promise<Service[]> {

    let url: string = this.configuration.backendUrl + "/api/bus/service/"+id;

    return await this.httpClient.get(url, () => { },
      () => { }).toPromise<Service[]>();
  }

  //add service for bus
  async addServiceForBus(service: BusServiceDto): Promise<any> {

    let url: string = this.configuration.backendUrl + "/api/bus/service";
    return await this.httpClient.post(url, service,
      () => { },
      () => { }).toPromise<any>();
  }

  //remove service from bus
  async deleteServiceForBus(serviceId: string): Promise<any> {

    let url: string = this.configuration.backendUrl + "/api/bus/service/" + serviceId;
    return await this.httpClient.delete(url,
      () => { },
      () => { }).toPromise<any>();
  }

  //set service as done
  async updateServiceAsDone(id: string): Promise<Service> {

    let url: string = this.configuration.backendUrl + "/api/bus/service/"+id;
    return await this.httpClient.patch(url, undefined,
      () => { },
      () => { }).toPromise<Service>();
  }

  // all types
  async getAllBusTypes(): Promise<string[]> {

    let url: string = this.configuration.backendUrl + "/api/bus/types";

    return await this.httpClient.get(url, () => { },
      () => { }).toPromise<string[]>();
  }

  // create bus
  async createBus(bus: Bus): Promise<Bus> {

    let url: string = this.configuration.backendUrl + "/api/bus";
    return await this.httpClient.post(url, bus,
      () => { },
      () => { }).toPromise<Bus>();
  }

  // update bus
  async updateBus(bus: Bus): Promise<Bus> {

    let url: string = this.configuration.backendUrl + "/api/bus";
    return await this.httpClient.patch(url, bus,
      () => { },
      () => { }).toPromise<Bus>();
  }

  // delete bus
  async deleteBus(bus: Bus): Promise<any> {

    let url: string = this.configuration.backendUrl + "/api/bus?id="+bus.id;
    return await this.httpClient.delete(url,
      () => { },
      () => { }).toPromise<any>();
  }
}
